<div class="card">
    @if(config()?.exportable){
        <p-toolbar styleClass="mb-6">
            <ng-template #start>
                <p-skeleton width="8rem" height="2.5rem" borderRadius="8px" class="mr-2"/>
                @if(config()?.selectable){
                    <p-skeleton width="8rem" height="2.5rem" borderRadius="8px" />
                }
            </ng-template>
    
            <ng-template #end>
                @if(config()?.exportable){
                    <p-skeleton width="8rem" height="2.5rem" borderRadius="8px" />
                }
            </ng-template>
        </p-toolbar>
    }
    <p-skeleton height="2rem" width="10rem" styleClass="mb-2" />

    <p-table [showGridlines]="true" [value]="[{},{},{},{},{}]" [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template #caption>
            <div class="flex justify-between items-center flex-column sm:flex-row">
                <p-skeleton width="8rem" height="2.5rem" borderRadius="8px" class="mr-2"/>
                <p-iconfield iconPosition="left" class="ml-auto">
                    <p-inputicon>
                        <i class="pi pi-search"></i>
                    </p-inputicon>
                    <p-skeleton width="12rem" height="2.5rem" borderRadius="8px" />
                </p-iconfield>
            </div>
        </ng-template>
        <ng-template #header>
            <tr>
                @if(config()?.selectable){
                    <th style="width: 3rem"><p-tableHeaderCheckbox /></th>
                }
                @for(col of config()?.columns; track col.field){
                    <th [pSortableColumn]="col.field" [style.min-width.rem]="16">
                        {{ col.header }}
                        <p-sortIcon [field]="col.field" />
                    </th>
                }
                <th style="width: 10%" class="text-center" pFrozenColumn alignFrozen="right">Acciones</th>
            </tr>
        </ng-template>
        <ng-template #body let-item>
            <tr>
                @if(config()?.selectable){
                    <td style="width: 3rem"><p-skeleton /></td>
                }
                @for(col of config()?.columns; track col.field){
                    <td [style.min-width.rem]="16"><p-skeleton /></td>
                }
                <td class="text-center" alignFrozen="right" pFrozenColumn><p-skeleton /></td>
            </tr>
        </ng-template>
    </p-table>
</div>
